import React from "react";
import styles from "../styles";
import localStyles from "./styles";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Button } from "@material-ui/core";
import { withUserProfile } from "../../../../../../userProfile/userProfileContext";
import Select from "../../../../../common/StyledSelect";
import { compose } from "recompose";
import GeocoderSearch from "../../../../Common/GeocoderSearchBox";
import CustomTextField from "../../DriverPopUp/common/CustomTextField";
import CustomBadge from "../../DriverPopUp/common/CustomBadge";
import { postData } from "../../../../../../api/componentAPIs";
import MESSAGES from "../../../../../../appMessages";
import Events from "../../../../../../utilities/EventEmitter";
import { withSnackbar } from "notistack";
import { getArrivedAtStopId, isTrailerDropFieldVisible } from "../utils";
class TrailerDropForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorInfo: {
        address: null,
        customerName: null,
        customer: null,
        locationName: null,
        agentDetail: null,
      },
      address: "",
      customerName: "",
      customer: "",
      locationName: "",
      agentDetail: "",
      customerNames: [],
      dropAddress: {
        longitude: "",
        latitude: "",
        zip: "",
        city: "",
        state: "",
        address: "",
      },
    };
  }

  trailerDroppedStatus = (data) => {
    const { success } = data;
    if (success) {
      this.onTrailerDropSucceed();
    } else {
      this.onTrailerDropFailed();
    }
  };

  componentWillUnmount() {
    Events.off("trailerDropped", this.trailerDroppedStatus);
  }

  componentDidMount() {
    Events.on("trailerDropped", this.trailerDroppedStatus);

    const customers = this.getCustomers();
    this.setState({
      customerNames: customers,
      customer: customers.length ? customers[0].value : "",
    });
  }

  getLocationDetails = ([longitude, latitude], zip, address, location) => {
    if (longitude && latitude && address) {
      this.setState(
        {
          dropAddress: {
            longitude: longitude,
            latitude: latitude,
            zip: zip,
            city: location.City,
            state: location.State,
            address: location.StreetAddress,
          },
        },
        () => this.handleChange("address")(address)
      );
    }
  };

  isDropAddressValid = () => {
    const {
      dropAddress: { longitude, latitude },
      address,
    } = this.state;
    return longitude && latitude && address;
  };

  handleChange = (field) => (value) => {
    this.setState(
      {
        [field]: value,
      },
      () => this.updateErrors(field,value)
    );
  };

  updateErrors = (field, value) => {
    this.setState((prevState) => ({
      errorInfo: {
        ...prevState.errorInfo,
        [field]: this.getIfValueRequired(field, value),
      },
    }));
  };

  getCustomers = () => {
    let stops = this.props.filteredStops.map((stop) => {
      return { label: stop.name, value: stop.name };
    });
    stops.push({ label: "Other", value: "other" });
    return stops;
  };

  getIfValueRequired = (filedName, value) => {
    if (filedName === "address") {
      if (!value) {
        return "* Required";
      } else if (!this.isDropAddressValid()) {
        return "* Invalid Address";
      }
      return null;
    }
    if (
      isTrailerDropFieldVisible(filedName, this.props.dropType, this.state) &&
      !value
    ) {
      return "* Required";
    }
    return null;
  };

  getErrors = () => {
    return {
      address: this.getIfValueRequired("address", this.state.address),
      customer: this.getIfValueRequired("customer", this.state.customer),
      customerName: this.getIfValueRequired(
        "customerName",
        this.state.customerName
      ),
      locationName: this.getIfValueRequired(
        "locationName",
        this.state.locationName
      ),
      agentDetail: this.getIfValueRequired(
        "agentDetail",
        this.state.agentDetail
      ),
    };
  };

  onSubmit = () => {
    const errors = this.getErrors();
    this.setState({
      errorInfo: errors,
    });
    const hasValidInputs = Object.values(errors).every((v) => v === null);

    if (!hasValidInputs) {
      return;
    }

    this.props.showHideLoader(true);
    const { userData, routeData, dropType } = this.props;
    const { customer, customerName, dropAddress } = this.state;

    const requestData = {
      terminalCode: userData.userProfile.terminal.code,
      driverId: routeData.driverId,
      dispatchId: routeData.dispatchId,
      routeId: routeData.routeId,
      stopId: getArrivedAtStopId(routeData),
      dropType: dropType,
      customerName: customer === "other" ? customerName : customer,
      locationName: this.getLocationName(),
      dropAddress: dropAddress.address,
      dropCity: dropAddress.city,
      dropState: dropAddress.state,
      dropZip: dropAddress.zip,
      longitude: dropAddress.longitude,
      latitude: dropAddress.latitude,
    };

    postData("TrailerDrop", requestData)
      .then((response) => {
        if (response?.status !== 204) {
          this.onTrailerDropFailed();
        }
      })
      .catch(() => {
        this.onTrailerDropFailed();
      });
  };

  getLocationName = () => {
    const { locationName, customer, customerName } = this.state;
    const { dropType } = this.props;

    if (dropType == "TemporaryLocation") {
      return locationName;
    } else if (dropType === "AgentInterline") {
      return customerName;
    }
    return customer === "other" ? customerName : customer;
  };

  onTrailerDropFailed = () => {
    this.props.enqueueSnackbar(MESSAGES.TRAILER_DROP.FAILURE, {
      variant: "error",
    });
    this.props.showHideLoader(false);
  };

  onTrailerDropSucceed = () => {
    this.props.enqueueSnackbar(MESSAGES.TRAILER_DROP.SUCCESS, {
      variant: "success",
    });
    this.props.showHideLoader(false);
    this.props.goBack();
  };

  onClearSearch = (value = "") => {
    this.setState(
      {
        dropAddress: {
          longitude: "",
          latitude: "",
          zip: "",
          city: "",
          state: "",
          address: "",
        },
      },
      () => this.handleChange("address")(value)
    );
  };

  render() {
    const { classes, trailerNumber, shipmentData, isLoading, dropType } =
      this.props;
    const { totalBills, totalPieces, totalHu, totalWeight } = shipmentData;
    const { errorInfo, customerNames } = this.state;
    const theme = this.props.userData.userProfile.theme;
    return (
      <React.Fragment>
        <Grid container className={classes.innerContainer}>
          <Grid xs={12}>
            <div className={classes.headerText}>TRAILER DETAILS</div>
            <div className={classes.subHeaderText}>
              TRAILER# {trailerNumber}
            </div>
            <div className={`${classes.flexRow} ${classes.trailerData}`}>
              <div className={classes.trailerInfo}>
                <CustomBadge
                  value={totalBills ? totalBills : "0"}
                  labelText="Bills"
                />
                <CustomBadge
                  value={totalPieces ? totalPieces : "0"}
                  labelText="Pieces"
                />
                <CustomBadge value={totalHu ? totalHu : "0"} labelText="HU" />
                <CustomBadge
                  value={totalWeight ? totalWeight : "0"}
                  labelText="LBS"
                />
              </div>
            </div>
          </Grid>
          <Grid xs={12}>
            <div className={classes.headerText}>LOCATION DETAILS</div>
            <div className={classes.searchRow}>
              <div
                className={`${classes.editorContainer} ${
                  Boolean(errorInfo?.address) && "error"
                }`}
              >
                <GeocoderSearch
                  getLocationDetails={this.getLocationDetails}
                  inputValue={this.state.address}
                  geocoderTheme={theme.themeName}
                  error={Boolean(errorInfo?.address)}
                  onClear={this.onClearSearch}
                ></GeocoderSearch>
                {Boolean(errorInfo?.address) && (
                  <div
                    className={`MuiFormHelperText-root MuiFormHelperText-error ${classes.errorMessageVisible}`}
                  >
                    {errorInfo?.address}
                  </div>
                )}
              </div>
            </div>
          </Grid>
          {isTrailerDropFieldVisible("locationName", dropType) ? (
            <Grid xs={12}>
              <div className={classes.headerText}>Location Name</div>
              <div className={classes.flexRow}>
                <CustomTextField
                  label="Location Name"
                  value={this.state.locationName}
                  handleChange={this.handleChange("locationName")}
                  error={this.state.errorInfo?.locationName}
                  margin="dense"
                />
              </div>
            </Grid>
          ) : null}
          {isTrailerDropFieldVisible("agentDetail", dropType) ? (
            <Grid xs={12}>
              <div className={classes.headerText}>Agent/Interline Details</div>
              <div className={classes.flexRow}>
                <CustomTextField
                  label="Agent/Interline Name"
                  value={this.state.agentDetail}
                  handleChange={this.handleChange("agentDetail")}
                  error={this.state.errorInfo?.agentDetail}
                  margin="dense"
                />
              </div>
            </Grid>
          ) : null}
          <Grid xs={12}>
            {isTrailerDropFieldVisible("customer", dropType) ? (
              <>
                <div className={classes.headerText}>CUSTOMER DETAILS</div>
                <div className={classes.flexRow}>
                  <Select
                    textFieldProps={{
                      id: "Customer",
                      label: "",
                      variant: "outlined",
                    }}
                    value={this.state.customer}
                    onChange={(item) => {
                      this.handleChange("customer")(item.value);
                    }}
                    error={Boolean(this.state.errorInfo?.customer)}
                    helperText={this.state.errorInfo?.customer}
                    data={customerNames}
                    isNotClearable={true}
                    margin="dense"
                    rootClass={classes.selectRoot}
                  />
                </div>
              </>
            ) : null}

            {this.state.customer === "other" &&
            isTrailerDropFieldVisible("customerName", dropType, this.state) ? (
              <div className={classes.flexRow}>
                <CustomTextField
                  label="Customer Name"
                  value={this.state.customerName}
                  handleChange={this.handleChange("customerName")}
                  error={this.state.errorInfo?.customerName}
                  margin="dense"
                />
              </div>
            ) : null}
          </Grid>

          <Button
            color="primary"
            variant="contained"
            fullWidth
            className={`${classes.confirmButton} ${classes.completeDropButton}`}
            onClick={this.onSubmit}
            disabled={isLoading}
            classes={{
              disabled: classes.disabledConfirmButton,
            }}
          >
            COMPLETE DROP
          </Button>
        </Grid>
      </React.Fragment>
    );
  }
}

export default compose(
  withSnackbar,
  withUserProfile,
  withStyles(
    (theme) => ({
      ...styles(theme),
      ...localStyles(theme),
    }),
    { withTheme: true }
  )
)(TrailerDropForm);
